import { RangePickerValues } from '@models/interfaces';

export const reverseType = (type: keyof RangePickerValues) =>
  type === 'from' ? 'to' : 'from';
